import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

class HttpClient {
  private axios: AxiosInstance;

  constructor({ baseUrl }: { baseUrl: string }) {
    this.axios = axios.create({
      baseURL: baseUrl,
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });
  }

  public get(url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.axios.get(url, options);
  }

  public post(url: string, body: any, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.axios.post(url, body, options);
  }

  public delete(url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.axios.delete(url, options);
  }
}

export default HttpClient;
